import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { deleteCookie, getCookie, getParam } from '../helpers/helpers';

// Dependencies
import { LaunchDarkly, FeatureFlag } from 'react-launch-darkly';
import jwt_decode from 'jwt-decode';
import LogRocket from 'logrocket';

// Components
import Header from './Common/Header';
import DelayRender from './Common/DelayRender';
import Footer from './Common/Footer';
import Loader from './Common/Loader';
import TallyLoader from './Common/TallyLoader';
import Modal from './Common/Modal';
import Dialog from './Common/Dialog';
import Confirm from './Common/Confirm';
import Prompt from './Common/Prompt';
import ExpireWarning from './Common/ExpireWarning';
import Toaster from './Common/Toaster';
import Notice from './Common/Notice';
import Notification from './Common/Notification';
import Calculator from './Common/Calculator';
import { config, setToken } from '../config';

// Store
import store from '../stores/';

class App extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.checkToken = this.checkToken.bind(this);
    this.refresh = this.refresh.bind(this);
    this.renderAgreements = this.renderAgreements.bind(this);
    this.renderZDChat = this.renderZDChat.bind(this);
  }

  componentWillMount() {
    const { SessionStore, HelpStore } = store;

    this.state = {
      test: false
    }

    if(window.performance) {
      if(performance.navigation.type === 1) {
        console.log('User refreshed.')
      }
    }

    // Add token to session storage
    if(SessionStore.hasSessionStorage) {
      if(sessionStorage.getItem('token') && this.props.location.query.token) {
        sessionStorage.removeItem('token');
      }

      if(!sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', this.props.location.query.token);
      }
    } else {
      if(getCookie('token') && this.props.location.query.token) {
        deleteCookie('token');
      }

      if(!getCookie('token')) {
        document.cookie = `token=${this.props.location.query.token}`;
      }
    }

    // Check authorization. If authorized, hit the check token endpoint.
    this.checkAuthorization();

    // Set token to api header and store in SessionStore
    if(SessionStore.hasSessionStorage) {
      setToken(sessionStorage.getItem('token'));

      SessionStore.token = sessionStorage.getItem('token');
    } else {
      setToken(getCookie('token'));

      SessionStore.token = getCookie('token');
    }

    // Get translations
    if(!SessionStore.translationLoaded) {
      SessionStore.getTranslation(SessionStore.locale);
    }

    // Get help documents
    if(!HelpStore.helpLoaded) {
      HelpStore.getHelp();
    }

    // Redirect VTC users
    const userAgent = document.querySelector('html').getAttribute('data-ua');

    if(userAgent.indexOf('VTC') > -1 && this.props.router.pathname !== 'vtc') {
      this.redirectVTC()
    }
  }

  redirectVTC() {
    this.props.router.push({
      pathname: 'vtc',
    });
  }

  /*
  componentDidMount() {
    // Check browser support
    store.SessionStore.checkBrowser();
  }
   */

  checkAuthorization() {
    const _this = this;
    const { SessionStore } = store;
    let token = null;

    const tokenInterval = setInterval(function(){
      if(SessionStore.hasSessionStorage) {
        token = sessionStorage.getItem('token');
      } else {
        token = getCookie('token');
      }

      if(token && token !== 'undefined') {
        clearInterval(tokenInterval);

        // Log referrer for debugging
        console.log('Referrer:');
        console.log(document.referrer);

        // Log launch url for debugging
        console.log('Launch URL:');
        console.log(window.location.href);

        // Log token for debugging
        console.log('Token:')
        console.log(token);

        const decodedToken = jwt_decode(token);

        if(decodedToken.errorCode === '1110') {
          // If unauthorized, send to unauthorized page
          window.location = `/#/unauthorized?token=${token}`
        } else {
          // Otherwise hit the check token endpoint
          _this.checkToken()
        }
      }
    }, 100);
  }

  componentWillUpdate(nextProps) {
    var cssId = 'accountCss'
    const { SessionStore } = store;

    let head = document.getElementsByTagName('head')[0];
    let link = document.createElement('link');

    if(typeof store.SessionStore.profile.firstName !== 'undefined') {
      SessionStore.checkProfile();
    }

    if(SessionStore.hasSessionStorage) {
      if(sessionStorage.getItem('iam')) {
        SessionStore.createValidate(sessionStorage.getItem('iam'), JSON.parse(sessionStorage.getItem('iam')).iam)
      }

      if(sessionStorage.getItem('userData') && JSON.parse(sessionStorage.getItem('userData')).cssUrl) {
        if(!document.getElementById(cssId) && JSON.parse(sessionStorage.getItem('userData')).cssUrl) {
          link.id   = cssId;
          link.rel  = 'stylesheet';
          link.type = 'text/css';
          link.href = JSON.parse(sessionStorage.getItem('userData')).cssUrl
          link.media = 'all';
          head.appendChild(link);
        }
      }
    } else {
      if(getCookie('iam')) {
        SessionStore.createValidate(getCookie('iam'), JSON.parse(getCookie('iam')).iam)
      }

      if(getCookie('userData') && JSON.parse(getCookie('userData')).cssUrl) {
        if (!document.getElementById(cssId) && JSON.parse(getCookie('userData')).cssUrl) {
          link.id   = cssId;
          link.rel  = 'stylesheet';
          link.type = 'text/css';
          link.href = JSON.parse(getCookie('userData')).cssUrl
          link.media = 'all';
          head.appendChild(link);
        }
      }
    }

    // Get current and next url and remove leading and trailing slashes
    const thisPath = this.props.location.pathname.replace(/^\/|\/$/g, '');
    const nextPath = nextProps.location.pathname.replace(/^\/|\/$/g, '');

    // If we’re moving to a new URL, focus the main content
    if(thisPath !== nextPath) {
      let contentFocus = setInterval(function(){
        if(document.querySelector('#main-content')) {
          document.querySelector('#main-content').focus();
          clearInterval(contentFocus);
          window.scrollTo(0, 0);
        }
      }, 100);
    }

    // Set the feature in the HelpStore
    store.HelpStore.feature = nextProps.route.feature;
  }

  checkToken() {
    const { SessionStore } = store;
    SessionStore.checkToken();
  }

  refresh() {
    const { router } = this.props;
    const thisLocation = this.props.router.location;

    router.replace('/refresh');

    setTimeout(function(){
      router.replace({ pathname: thisLocation.pathname, query: thisLocation.query });
    });
  }

  renderAgreements() {
    const _this = this;
    const agrScript = document.querySelector('#agr-ui');

    if(!agrScript) {
      let agr = document.createElement('script');
      agr.id = 'agr-ui';
      agr.type = 'text/javascript';
      agr.async = true;
      agr.src = config.agreementUISrc;

      agr.onload = function(){
        _this.checkAgreements(process.env.REACT_APP_ENVIRONMENT);
      };

      document.body.appendChild(agr);
    }

    return null;
  }

  checkAgreements(env) {
    const { userData } = store.SessionStore;

    if(getParam('skipAgreements', window.location.href) === 'true') {
      return;
    }

    let agrOpts = {
      mode: 'popup',
      location: 'general-user-agreements',
      target: userData.userSid,
      account: userData.deploymentSid
    }

    if(env === 'production') {
      agrOpts.application = 'AP6800b9e2e1794dbbbf6ad866194821d3';
      window.Agreements.setup(agrOpts);
    } else {
      agrOpts.application = 'APfb4f76ee1dc24d058048fdaed04f56f1';
      window.Agreements.setup(agrOpts);
    }
  }

  initializeLogRocket() {
    // Initialize LogRocket if it’s enabled
    if(process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'production-b') {
      if(!store.SessionStore.logRocketInit) {
        console.log('====================');
        console.log('Starting LogRocket');
        console.log('====================');

        LogRocket.init(config.logRocket);
        store.SessionStore.logRocketInit = true;
      }
    }

    return null;
  }

  renderZDChat() {
    const { profile, userData } = store.SessionStore;
    const zdScript = document.querySelector('#ze-snippet');

    if(!zdScript) {
      let zdc = document.createElement('script');
      zdc.id = 'ze-snippet';
      zdc.type = 'text/javascript';
      zdc.async = true;
      zdc.src = 'https://static.zdassets.com/ekr/snippet.js?key=a3206868-bdac-4af5-a921-ee51087a581e';

      zdc.onload = function() {
        window.zE(function(){
          window.zE.identify({
            name: `${profile.firstName} ${profile.lastName}`,
            email: profile.email,
            organization: userData.smarterProctoring ? userData.smarterProctoring.appInstallName : ''
          });

          window.zE('webWidget', 'updateSettings', {
            webWidget: {
              offset: {
                vertical: '44px'
              }
            }
          });
        });
      }

      document.body.appendChild(zdc);
    }

    return null;
  }

  handleBlockedUser(isBlocked, fullBlock = false) {
    const { UserStore } = store;
    if (isBlocked) {
      UserStore.handleBlockedUser(fullBlock);
    }

    return null;
  }

  shouldRenderZD() {
    return (
      <FeatureFlag
        flagKey="zendesk-chat"
        renderFeatureCallback={this.renderZDChat}
      />
    );
  }

  renderSFChat() {
    const { userData } = store.SessionStore;
    const optionsDefined = !!window.inAppHelpOptions;
    const token = sessionStorage.getItem('token');

    if (!optionsDefined) {
      window.inAppHelpOptions = {
        token: token,
        application_sid: userData.smarterProctoring.sid,
        context: userData.role.toLowerCase() === 'administrator' ? 'admin_account' :'course_account',
        sids: {
          course_sid: userData.courseSid,
          enrollment_sid: userData.enrollmentSid,
          install_sid: userData.installSid,
        }
      }

      const script = document.createElement('script');
      script.src = config.supportScriptUrl;
      script.type = 'text/javascript';
      script.onload = () => window.initHelpCenter();

      document.body.appendChild(script);
    }

    return null;
  }

  handleChromeStoreId(value) {
    const { SessionStore } = store;

    config.extensionUrl = `https://chrome.google.com/webstore/detail/smarterproctoring/${value}`;
    config.extensionId = value;
    config.extensionManifestUrl = `https://smarterproctoring-extension.s3.amazonaws.com/manifest.${value}.json`

    // Get extension info from the manifest
    SessionStore.getExtensionInfo();

    return null;
  }

  render() {
    const { SessionStore } = store;
    let test = null;

    // Environment (used by LaunchDarkly)
    let environment = 'develop';

    if(process.env.REACT_APP_ENVIRONMENT === 'production') {
      environment = 'production'
    }

    if(process.env.REACT_APP_ENVIRONMENT === 'stage') {
      environment = 'stage'
    }

    // Store iam and userData
    if(SessionStore.hasSessionStorage) {
      test = sessionStorage.getItem('iam') && sessionStorage.getItem('userData');
    } else {
      test = getCookie('iam') && getCookie('userData');
    }

    // Import styles
    if(!document.querySelector('link[href*="screen.css"]')) {
      const { highContrast, dyslexic } = store.SessionStore;

      // Default stylesheet
      let defaultStyles = document.createElement('link');
      defaultStyles.rel = `${highContrast ? 'alternate stylesheet' : 'stylesheet '}`;
      defaultStyles.type = 'text/css';
      defaultStyles.href = './static/css/screen.css';

      if(document.querySelector('html').className.indexOf('firefox') > -1) {
        defaultStyles.title = 'Default';
      }

      // High-contrast stylesheet
      let highContrastStyles = document.createElement('link');
      highContrastStyles.rel = `${highContrast ? 'stylesheet' : 'alternate stylesheet'}`;
      highContrastStyles.type = 'text/css';
      highContrastStyles.href = './static/css/hi-c.css';

      if(document.querySelector('html').className.indexOf('firefox') > -1) {
        highContrastStyles.title = 'High Contrast';
      }

      // Dyslexic stylesheet
      let dyslexicStyles = document.createElement('link');
      dyslexicStyles.rel = `${dyslexic ? 'stylesheet' : 'alternate stylesheet'}`;
      dyslexicStyles.type = 'text/css';
      dyslexicStyles.href = './static/css/open-dyslexic.css';

      if(document.querySelector('html').className.indexOf('firefox') > -1) {
        dyslexicStyles.title = 'Open Dyslexic';
      }

      document.head.appendChild(defaultStyles);
      document.head.appendChild(highContrastStyles);
      document.head.appendChild(dyslexicStyles);
    }

    // Detect touch device
    const docRoot = document.querySelector('html');
    if ('ontouchstart' in document.documentElement) {
      docRoot.classList.add('touch');
    }

    // Don’t return the app until the user data is set
    if(typeof store.SessionStore.userData.userSid === 'undefined') {
      return (
        <div className="viewport">
          {store.SessionStore.dialog &&
            <Dialog store={store} />
          }
        </div>
      )
    } else {
      // LaunchDarkly user config
      const ldConfig = {
        key: store.SessionStore.userData.userSid,
        custom: {
          domain: window.location.hostname,
          environment: environment,
          role: SessionStore.userData.role,
          installSid: SessionStore.userData.installSid,
          deploymentSid: SessionStore.userData.deploymentSid,
          enrollmentSid: SessionStore.userData.enrollmentSid,
          courseSid: SessionStore.userData.courseSid,
          // offeringSid: SessionStore.userData.offeringSid,
          integrationSid: SessionStore.userData.integrationSid,
          userAgent: navigator.userAgent
        }
      }
      // We cannot be assured email address is set, so we will do it conditionally...
      if (SessionStore.userData && SessionStore.userData.email) {
        ldConfig.custom.email = SessionStore.userData.email;
      }

      // Return the view
      return (
        <LaunchDarkly clientId={config.ldApiKey} user={ldConfig}>          
          <div className="viewport">

          <FeatureFlag
              flagKey="maintenance-message"
              renderFeatureCallback={function(flagValue) {
                if(flagValue && typeof flagValue === 'object' && flagValue.message !== undefined){
                  // Redirect to maintenance page
                  window.location.href = `/#/maintenance`;
                  return null;
                }else{
                  return null;
                }
              }}
            />

            <FeatureFlag
              flagKey="block-sp-access"
              renderFeatureCallback={(flagVal) => this.handleBlockedUser(flagVal, true)}
            />

            <FeatureFlag
              flagKey="block-live-access"
              renderFeatureCallback={(flagVal) => this.handleBlockedUser(flagVal)}
            />

            <FeatureFlag
              flagKey="agreements"
              renderFeatureCallback={this.renderAgreements}
            />

            <FeatureFlag
              flagKey="extension-chrome-store-id"
              renderFeatureCallback={this.handleChromeStoreId}
            />

            <FeatureFlag
              flagKey="log-rocket"
              renderFeatureCallback={this.initializeLogRocket}
            />

            <DelayRender test={test}>
              {store.SessionStore.notice &&
                <Notice store={store} />
              }

              {!store.SessionStore.hideHeader &&
                <Header refresh={this.refresh} store={store} {...this.props} />
              }

              {React.cloneElement(this.props.children, this.props)}

              {!store.SessionStore.hideFooter &&
                <Footer store={store} />
              }

              {store.SessionStore.expireWarning &&
                <ExpireWarning store={store} />
              }

              {store.SessionStore.dialog &&
                <Dialog store={store} />
              }

              {store.SessionStore.confirm &&
                <Confirm store={store} />
              }

              {store.SessionStore.prompt &&
                <Prompt store={store} />
              }

              {store.SessionStore.toaster &&
                <Toaster store={store} />
              }

              {store.SessionStore.notification &&
                <Notification store={store} {...this.props} />
              }

              {store.SessionStore.modalContent &&
                <Modal store={store} />
              }

              {store.SessionStore.calculator &&
                <Calculator store={store} />
              }

              {/*store.SessionStore.browserUnsupported &&
                <div className={`toaster toaster--warning toaster--sm`}>
                  <div className="wrap">
                    <p>You are using an unsupported browser. We recommend that you <a href="http://outdatedbrowser.com/" target="_blank">update your browser</a> for the best experience.</p>
                  </div>
                </div>
              */}

              {
                (
                  store.SessionStore.loading ||
                  store.SessionStore.loadingClass ||
                  store.SessionStore.backgroundLoadingCalls.indexOf('getSingleApproval') >= 0
                ) && !store.SessionStore.tallyLoad &&
                <Loader store={store} />
              }

              {store.SessionStore.tallyLoad &&
                <TallyLoader store={store} routing={this.props.router} />
              }

              {store.SessionStore.profile.firstName &&
                <FeatureFlag
                  flagKey="salesforce-chat"
                  renderFeatureCallback={this.renderSFChat}
                  renderDefaultCallback={()=>this.shouldRenderZD()}
                />
              }
            </DelayRender>
          </div>
        </LaunchDarkly>
      )
    }
  }
}

export default observer(App);



// WEBPACK FOOTER //
// ./src/app/components/App.js